import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../_services/local-storage.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {

  showProfileTab: Boolean = true;
  showTagManagementTab: Boolean = false;
  showPlanTab: Boolean = false;
  showCreditsTab: Boolean = false;
  showTeamManagementTab: Boolean = false;
  showEmailTemplatesTab: Boolean = false;
  showCampaignsLimitsTab: Boolean = false;
  showEmailIntegrationTab: Boolean = false;
  showAtsIntegrationTab: Boolean = false;
  showAutopilotPermissionTab: Boolean = false;
  isteamAdmin: boolean = false;
  isAISourcingEnabled: boolean = false;
  private roleChangedSubscription: Subscription;


  constructor(
    private router: Router,
    private location: Location,
    private localstorageservice: LocalStorageService
  ) {

    const tab = window.location.pathname;
    if (window.location.pathname === '/settings') {
      this.showProfileTab = true;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/tag-management') {
      this.showProfileTab = false;
      this.showTagManagementTab = true;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/plan') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = true;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/credits') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = true;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/team-management') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = true;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/email-templates') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = true;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/email-integrations') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = true;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/ats-integrations') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = true;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/autopilot-permission') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = true;
      this.showCampaignsLimitsTab = false;
    } else if (tab == '/settings/campaigns-limits') {
      this.showProfileTab = false;
      this.showTagManagementTab = false;
      this.showPlanTab = false;
      this.showCreditsTab = false;
      this.showTeamManagementTab = false;
      this.showEmailTemplatesTab = false;
      this.showEmailIntegrationTab = false;
      this.showAtsIntegrationTab = false;
      this.showAutopilotPermissionTab = false;
      this.showCampaignsLimitsTab = true;
    }
  }

  ngOnInit() {
    this.isteamAdmin = this.localstorageservice.getItem('role') == 'team admin' ? true : false;
    this.isAISourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess') == '1' ? true : false;

    this.roleChangedSubscription = this.localstorageservice.roleChanged$.subscribe(role => {
      if (role !== null) {
        this.isteamAdmin = role == 'team admin';
      }
    });
  }

  ngOnDestroy() {
    this.roleChangedSubscription?.unsubscribe();
  }


  onTabChange(tab: string) {
    switch (tab) {
      case 'profile': {
        this.showProfileTab = true;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings']);
        break;
      }
      case 'tag-management': {
        this.showProfileTab = false;
        this.showTagManagementTab = true;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/tag-management']);
        break;
      }
      case 'plan': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = true;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/plan']);
        break;
      }
      case 'credits': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = true;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/credits']);
        break;
      }
      case 'team-management': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = true;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/team-management']);
        break;
      }
      case 'email-templates': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = true;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/email-templates']);
        break;
      }

      case 'email-integrations': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = true;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/email-integrations']);
        break;
      }

      case 'ats-integrations': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = true;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = false;

        this.router.navigate(['/settings/ats-integrations']);
        break;

      }

      case 'autopilot-permission': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = true;
        this.showCampaignsLimitsTab = false;
        this.router.navigate(['/settings/autopilot-permission']);
        break;
      }

      case 'campaigns-limits': {
        this.showProfileTab = false;
        this.showTagManagementTab = false;
        this.showPlanTab = false;
        this.showCreditsTab = false;
        this.showTeamManagementTab = false;
        this.showEmailTemplatesTab = false;
        this.showEmailIntegrationTab = false;
        this.showAtsIntegrationTab = false;
        this.showAutopilotPermissionTab = false;
        this.showCampaignsLimitsTab = true;
        this.router.navigate(['/settings/campaigns-limits']);
        break;
      }
    }
  }


}
